<template>
  <div class="d-inline-flex mr-3 mb-3" style="width: 124px">
    <div class="mr-2">
      <peity :type="'donut'" :options="{'fill': ['#967bbd', '#ccbfdf'], 'innerRadius': 19, 'radius': 25 }" :data="data"></peity>
    </div>
    <div class="text-left">
      <label class="fs-sm mb-0 mt-1">{{ title }}</label>
      <h4 class="font-weight-bold mb-0">{{ text }}%</h4>
    </div>
  </div>
</template>

<script>
  import Peity from 'vue-peity'

  export default {
    props: ['title', 'text', 'data'],
    components: {
      Peity,
    },
  }
</script>